import { combineReducers } from 'redux'
import offers, { STATE_KEY as OFFERS_STATE_KEY } from './offers'

export const STATE_KEY = 'offers'

const reducer = combineReducers({
	[OFFERS_STATE_KEY]: offers
})

export default reducer